import { validateRule } from './validateRule';
import { getValidationMessage } from './getValidationMessage';
const VALIDATORS = {
    required: (rule, value) => {
        if (!rule)
            return true;
        if (value === null || value === undefined)
            return false;
        if (typeof value === 'string' && value.trim() === '')
            return false;
        return true;
    },
    pattern: (rule, value) => new RegExp(rule).test(value),
    minLength: (rule, value) => String(value).length >= rule,
    maxLength: (rule, value) => String(value).length <= rule,
    min: (rule, value) => !isNaN(Number(value)) && Number(value) >= rule,
    max: (rule, value) => !isNaN(Number(value)) && Number(value) <= rule
};
/**
 * Validates a value against a set of validation rules.
 *
 * @param {string} value - The value to validate.
 * @param {FieldValidation | undefined} validation - The validation rules.
 * @returns {string | null} - Error message if validation fails, null otherwise.
 */
export const validate = (value, validation) => {
    if (!validation)
        return null;
    let validationError = null;
    for (const key of Object.keys(validation)) {
        const ruleValue = validation[key];
        const validateFunc = VALIDATORS[key];
        if (ruleValue !== undefined && validateFunc) {
            validationError = validateRule(ruleValue, value, validateFunc, getValidationMessage(key, validation));
            if (validationError)
                break;
        }
    }
    return validationError;
};
